import { Button, type ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** The only action on a read-only dialog (TMMAPP-0089). A text Close stays beside a primary. */
export function DialogDoneButton({
  onClick,
  ...rest
}: { onClick: () => void } & Omit<ButtonProps, 'onClick' | 'children'>) {
  const { t } = useTranslation();
  return (
    <Button variant="contained" onClick={onClick} {...rest}>
      {t('common.done')}
    </Button>
  );
}
